export const socialMediaPlatforms = [
    { name: 'Facebook', icon: 'facebook-circle', baseUrl: 'https://facebook.com', userName: 'scoutshaegepoorters' },
    { name: 'Instagram', icon: 'instagram', baseUrl: 'https://www.instagram.com', userName: 'scouts_haegepoorters' },
]

export const secondaryContactPlatforms = [
    { name: 'Messenger', icon: 'messenger', baseUrl: 'https://m.me', userName: 'scoutshaegepoorters' },
]